module.exports = __webpack_public_path__ + "img/logo.c226413f.png";